import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from '../../components/Modal'
import { Select } from '../../components/Select'
import { Button } from '../../elements/Button'
import {
  fetchCourseWithIntakes,
  selectCourseOptionsForAdditionalCourses,
  selectIntakeOptions,
} from '../../redux/courseSlice'
import { useAppSelector } from '../../types/assets'
import { useIntakeContext } from './IntakeContext'
import { StyledAddCourses } from './styles'

type AddAdditionalCoursesModalProps = {
  showModal: boolean
  onClose: () => void
  intakeId: string
}

export const AddAdditionalCoursesModal = ({ intakeId, onClose, ...props }: AddAdditionalCoursesModalProps) => {
  const dispatch = useDispatch()

  const [selectedCourseId, setSelectedCourseId] = useState<string>()

  const [selectedIntakeId, setSelectedIntakeId] = useState<string>()

  const { addAdditionalCourses, selectedCourseIds } = useIntakeContext()

  const {
    courses: {
      coursesWithIntakes,
      loading: { all, one },
    },
  } = useAppSelector(state => state)

  const courseOptions = useAppSelector(state =>
    selectCourseOptionsForAdditionalCourses(state, intakeId, selectedCourseIds),
  )

  const intakeOptions = useAppSelector(state => selectIntakeOptions(state, selectedCourseId || '', intakeId))

  const onCourseSelect = (value: string) => {
    setSelectedCourseId(value)
    if (one?.[value] !== 'succeeded') {
      dispatch(fetchCourseWithIntakes(value))
    }
  }

  const onIntakeSelect = (value: string) => {
    setSelectedIntakeId(value)
  }

  const onAddCourse = () => {
    const intake = coursesWithIntakes[selectedCourseId!].intakes?.find(i => i.intakeGuid === selectedIntakeId!) || {}

    addAdditionalCourses(intake, selectedCourseId!)
    setSelectedIntakeId(undefined)
    setSelectedCourseId(undefined)
    onClose()
  }

  const disableIntakeSelect = !intakeOptions.length || one[selectedCourseId || ''] !== 'succeeded'

  const disableButton = !selectedCourseId || !selectedIntakeId
  const intakePlaceholder = one[selectedCourseId || ''] === 'loading' ? 'loading..' : 'Select an Intake...'
  const coursesPlaceholder = all === 'loading' ? 'loading..' : 'Select a Course...'

  const noIntakesMessage =
    !intakeOptions.length &&
    one[selectedCourseId || ''] === 'succeeded' &&
    'Sorry, there are no intakes available for this course'

  const onCloseModal = () => {
    setSelectedCourseId(undefined)
    setSelectedIntakeId(undefined)
    onClose()
  }
  return (
    <Modal
      onClose={onCloseModal}
      {...props}
      title="Add Additional Course"
    >
      <StyledAddCourses>
        <Select
          label="Course"
          value={courseOptions.filter(o => o.value === selectedCourseId)}
          placeholder={coursesPlaceholder}
          onChange={onCourseSelect}
          options={courseOptions}
        />
        {selectedCourseId && (
          <Select
            label="Intake"
            value={intakeOptions.filter(o => o.value === selectedIntakeId)}
            placeholder={intakePlaceholder}
            onChange={onIntakeSelect}
            options={intakeOptions}
            isDisabled={disableIntakeSelect}
            errorMessage={noIntakesMessage}
          />
        )}
        <Button
          label="Add Course"
          disabled={disableButton}
          onClick={onAddCourse}
        />
      </StyledAddCourses>
    </Modal>
  )
}
